import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { connect } from 'react-redux';
import { matchStartDateSortFunc } from '../../../../rendering-commons/Sorting';
import Match from './Match';
function filter(matches, startDate, endDate) {
    return matches.filter(function (m) { return m.get('startDate').isAfter(startDate) && m.get('startDate').isBefore(endDate); });
}
var League = function (props) {
    var league = props.league, matches = props.matches, timeFilter = props.timeFilter;
    var leagueMatchesIds = league.get('matches');
    var leaguesMatches = leagueMatchesIds.map(function (m) { return matches.get(m); });
    var matchesToShow = filter(leaguesMatches, moment(timeFilter).startOf('day'), moment(timeFilter).endOf('day'));
    var renderMatches = [];
    matchesToShow.sort(matchStartDateSortFunc).map(function (match) {
        renderMatches.push(_jsx(Match, { match: match, leagueName: league.get('name') }, match.get('id')));
    });
    return renderMatches;
};
League.propTypes = {
    timeFilter: PropTypes.any,
    matches: PropTypes.object.isRequired
};
var mapStateToProps = function (state) {
    return {
        matches: state.application.getIn(['timetable', 'matches'])
    };
};
League = connect(mapStateToProps)(League);
export default League;



// WEBPACK FOOTER //
// ./src/components/grid/live/timetable/League.jsx